module.exports = __webpack_public_path__ + "static/img/s-logo.43b3b3d.png";